import * as React from 'react';
import LandingPage from './pages/LandingPage/LandingPage';
import GettingStartedPage from './pages/GettingStarted/GettingStartedPage';
import { Route, Router } from 'react-router-dom';
import history from 'src/helpers/history';
import MatchPage from './pages/MatchPage/MatchPage';
import BecomeAHostPage from './pages/BecomeAHost/BecomeAHostPage';
import ThankYouPage from './pages/BecomeAHost/components/ThankYouPage';
import PostCheckoutPage from './pages/PostCheckout/PostCheckoutPage';
import FAQPage from './pages/FAQPage/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicy/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfService/TermsOfServicePage';
import AboutUsPage from './pages/AboutUs/AboutUsPage';
import CustomerPaymentPage from './pages/CustomerPayment/CustomerPaymentPage';
import PostPaymentPage from './pages/CustomerPayment/PostPaymentPage';

class App extends React.Component {
  public render() {
    return (
      <Router history={history}>
        <div>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/getting-started" component={GettingStartedPage} />
          <Route exact path="/match" component={MatchPage} />
          <Route exact path="/become-a-host" component={BecomeAHostPage} />
          <Route exact path="/become-a-host/thanks" component={ThankYouPage} />
          <Route exact path="/post-checkout" component={PostCheckoutPage} />
          <Route exact path="/faq" component={FAQPage} />
          <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
          <Route exact path="/terms-of-service" component={TermsOfServicePage} />
          <Route exact path="/about-us" component={AboutUsPage} />
          <Route path="/payment/:orderNumber" component={CustomerPaymentPage} />
          <Route path="/post-payment" component={PostPaymentPage} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx